import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import "@fontsource/ibm-plex-mono/700.css";
import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";
import "@fontsource/ubuntu/700.css";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import { CloseButton } from "../common/Alert";
import { APP_NAME, APP_NAMES } from "../constants";
import { AuthProvider } from "../contexts/AuthContext/AuthProvider";
import { MainProviderProps } from "../interfaceTypes";
import { customTheme } from "../theme";

/**
 * MainProvider component provides a wrapper with essential providers and configurations
 * to enable certain functionalities throughout the application.
 *
 * @prop {React.ReactNode} children - The content to be wrapped by the MainProvider.
 * @prop {string} appName - the name of application that main provider wraps
 */
export const MainProvider = ({ children, appName }: MainProviderProps) => {
  appName === APP_NAMES.ADMIN
    ? localStorage.setItem(APP_NAME, APP_NAMES.ADMIN)
    : localStorage.setItem(APP_NAME, APP_NAMES.PORTAL);

  return (
    <SnackbarProvider
      maxSnack={5}
      autoHideDuration={5000}
      action={(key) => <CloseButton id={key} />}
      preventDuplicate={true}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      classes={{ containerRoot: "snackbarProvider" }}
    >
      <ThemeProvider theme={customTheme}>
        <CssBaseline />

        <AuthProvider>{children}</AuthProvider>
      </ThemeProvider>
    </SnackbarProvider>
  );
};
